export const forms = state => state.forms
export const notifications = state => state.notifications
export const workflow = state => state.workflows
export const skins = state => state.skins
export const ui = state => state.ui
export const api = state => state.api
export const table = state => state.table
export const dynamicWorkflows = state => state.dynamicWorkflows
export const navigation = state => state.navigation
export const config = state => state.config



// WEBPACK FOOTER //
// ./src/vuex/getters.js